//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            loading: true,
            headers: ['Recipient', 'Subject', 'Date Sent', 'Template', 'Read'],
            fields: ['recipient', 'subject', 'sent_date', 'template', 'isRead'],
            notifications: [],
            totalRecord: 0
        };
    },

    methods: {
        getNotifications: function getNotifications() {

            var self = this;

            window.axios.get('/prototype/notifications/all').then(function (response) {

                var notes = response.data,
                    outputData = [];

                notes.forEach(function (n, index) {

                    var sentDate = moment(n.created_at),
                        readDate = moment(n.marked_as_read_at),
                        rName = '';

                    n.units.forEach(function (item, index) {
                        rName += 'Unit: ' + item.name + '\n';
                    });

                    n.buildings.forEach(function (item, index) {
                        rName += 'Building: ' + item.name + '\n';
                    });

                    n.properties.forEach(function (item, index) {
                        rName += 'Property: ' + item.name + '\n';
                    });

                    n.persons.forEach(function (item, index) {
                        rName += 'Person: ' + item.name + '\n';
                    });

                    var item = {
                        id: n.id,
                        recipient: rName,
                        subject: n.subject,
                        sent_date: sentDate.format('MMMM Do YYYY [at] h:mm:ss a'),
                        template: n.template ? 'yes' : 'no',
                        isRead: n.marked_as_read_at ? readDate.format('MMMM Do YYYY [at] h:mm:ss a') : ''
                    };

                    outputData.push(item);
                });

                self.notifications = outputData;
                self.totalRecord = outputData.length;
            });
        }
    },
    created: function created() {
        Event.$on('refetch-notifications', this.getNotifications);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('refetch-notifications', this.getNotifications);
    },
    mounted: function mounted() {
        Event.$on('new notification', function () {
            Event.$emit('new-notification');
        });

        this.getNotifications();
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/notifications/NotificationHistory.vue
// module id = Rk+F
// module chunks = 0 1